export const accountingPeriodConstants = {
	GetList: {
		FAILURE : 'GET_LIST_ACCOUNTING_PERIOD_FAILURE',
		REQUEST : 'GET_LIST_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'GET_LIST_ACCOUNTING_PERIOD_SUCCESS'
	},
	GetPaged: {
		SUCCESS : 'GET_PAGED_ACCOUNTING_PERIOD_SUCCESS',
		REQUEST : 'GET_PAGED_ACCOUNTING_PERIOD_REQUEST',
		FAILURE : 'GET_PAGED_ACCOUNTING_PERIOD_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'CREATE_ACCOUNTING_PERIOD_SUCCESS',
		FAILURE : 'CREATE_ACCOUNTING_PERIOD_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'DELETE_ACCOUNTING_PERIOD_SUCCESS',
		FAILURE : 'DELETE_ACCOUNTING_PERIOD_FAILURE'
	},
	Change: {
		REQUEST : 'UPDATE_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'UPDATE_ACCOUNTING_PERIOD_SUCCESS',
		FAILURE : 'UPDATE_ACCOUNTING_PERIOD_FAILURE'
	},
	CLEAR: 'CLEAR_ACCOUNTING_PERIOD'
}